import { ReactComponent as SKu } from "./assets/img/icons/common/sku.svg";
import { ReactComponent as Billing } from "./assets/img/icons/common/billing.svg";
import UserRegistrationDetails from "./views/pages/users/userVerification/registration-verification";
import RakBeneficiaries from "views/pages/beneficiaries/rakbeneficiaries.js";
import RakProfiles from "views/pages/reports/rakprofiles.js";
import RakTransactions from "views/pages/reports/rak-transaction/raktransactions.js";

import RechargeBeneficiaries from "views/pages/beneficiaries/rechargebeneficiaries.js";
import RechargeTransaction from "./views/pages/reports/recharge-transaction/rakRechargetransactions.js";
import Rejected from "./views/pages/users/rejectedDetail/rejected";
import Updates from "./views/pages/users/updateDetail/updates";

import allUsers from "./views/pages/users/allUserDetail/allusers";
import registrations from "./views/pages/users/registartionDetail/registrations";

import ChangePassword from "./views/pages/settings/createnewuser/changepassword";
import Createuserheader from "./views/pages/settings/createnewuser/createuserheader";
import AuditTrail from "./views/pages/settings/audittrail/audittrail";
import BlockList from "./views/pages/settings/fraud-blacklist/blocklist";
import ManageUsers from "./views/pages/settings/manageusers";

import ProfileDetailsPage from "./views/pages/users/userdetails/profiledetails.js";
import Skucatalogfunctional from "./views/pages/skucatalog/skucatalogfunctional";
import BillingandMapping from "./views/pages/Billingandmapping/billingandmapping";
import SalaryAdvance from "./views/pages/salaryadvance/salaryadvance";

import ReferrerCode from "./views/pages/settings/ReferrerCode/referrerCode";
import CreateNewCode from "./views/pages/settings/ReferrerCode/createnewcode/createNewCode";
import NonRegisterUser from "./views/pages/users/nonRegisterUser/nonRegisterUser";

const routes = [
  {
    collapse: true,
    name: "Users",
    icon: "fas fa-user-friends",
    state: "dashboardsCollapse",
    isSuperAdmin: true,
    isAdmin: true,
    isVerifier: true,
    isUser: true,
    isECSAgent: true,
    views: [
      {
        path: "/registered-users",
        name: "Registered Users",
        component: allUsers,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: true,
      },
      {
        path: "/non-registered-users",
        name: "Non Registered Users",
        component: NonRegisterUser,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
      {
        path: "/verifications",
        name: "Verifications",
        component: registrations,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: false,
        isECSAgent: false,
      },
      {
        path: "/updates",
        name: "Updates",
        component: Updates,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: false,
        isECSAgent: false,
      },
      {
        path: "/rejected",
        name: "Rejections",
        component: Rejected,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: false,
        isECSAgent: false,
      },
      {
        path: "/user-profile",
        component: ProfileDetailsPage,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: true,
      },
      {
        path: "/registration-verification",
        component: UserRegistrationDetails,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: false,
        isUser: false,
        isECSAgent: false,
      },
    ],
  },
  {
    collapse: true,
    name: "Beneficiaries",
    icon: "fas fa-user-check",
    state: "examplesCollapse",
    isSuperAdmin: true,
    isAdmin: true,
    isVerifier: true,
    isUser: true,
    isECSAgent: false,
    views: [
      {
        path: "/rak-beneficiaries",
        name: "RAK Beneficiaries",
        component: RakBeneficiaries,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
      {
        path: "/recharge-beneficiaries",
        name: "Recharge Beneficiaries",
        component: RechargeBeneficiaries,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
      {
        path: "/CreateNewCode",
        name: "",
        component: CreateNewCode,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
    ],
  },

  {
    collapse: true,
    name: "Reports",
    icon: "fas fa-file-alt",
    state: "reportsCollapse",
    isSuperAdmin: true,
    isAdmin: true,
    isVerifier: true,
    isUser: true,
    isECSAgent: false,
    views: [
      {
        path: "/rakprofile",
        name: "RAK Profiles",
        component: RakProfiles,
        layout: "/admin",
        isSuperAdmin: false,
        isAdmin: false,
        isVerifier: false,
        isUser: false,
        isECSAgent: false,
      },
      {
        path: "/raktransaction",
        name: "RAK Transactions",
        component: RakTransactions,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
      {
        path: "/rechargetransaction",
        name: "Recharge Transactions",
        component: RechargeTransaction,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
    ],
  },
  {
    path: "/ReferrerCode",
    name: "Referrer Code",
    icon: "fas fa-book-open",
    //state: "examplesCollapse",
    layout: "/admin",
    component: ReferrerCode,
    isSuperAdmin: true,
    isAdmin: true,
    isVerifier: true,
    isUser: true,
    isECSAgent: false,
  },
  {
    path: "/skucatalog",
    name: "SKU Catalog",
    icon: "",
    Svg: SKu,
    layout: "/admin",
    component: Skucatalogfunctional,
    isSuperAdmin: true,
    isAdmin: true,
    isVerifier: true,
    isUser: true,
    isECSAgent: false,
  },

  {
    path: "/salaryadvance",
    name: "Salary Advance",
    icon: "fas fa-money-bill-alt",
    layout: "/admin",
    component: SalaryAdvance,
    isSuperAdmin: true,
    isAdmin: true,
    isVerifier: true,
    isUser: true,
    isECSAgent: false,
  },
  {
    path: "/billermapping",
    name: "Biller Mapping",
    icon: "",
    Svg: Billing,
    layout: "/admin",
    component: BillingandMapping,
    isSuperAdmin: true,
    isAdmin: false,
    isVerifier: false,
    isUser: false,
    isECSAgent: false,
  },
  {
    collapse: true,
    name: "Settings",
    icon: "ni ni-align-left-2 text-default",
    state: "tablesCollapse",
    isSuperAdmin: true,
    isAdmin: true,
    isVerifier: true,
    isUser: true,
    isECSAgent: true,
    views: [
      {
        path: "/change password",
        name: "Change Password",
        component: ChangePassword,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: true,
      },
      {
        path: "/ManageUsers",
        name: "Manage Users",
        component: ManageUsers,
        layout: "/admin",
        isSuperAdmin: false,
        isAdmin: false,
        isVerifier: false,
        isUser: false,
        isECSAgent: false,
      },
      {
        path: "/create-new-user",
        //name: "Audit Trail",
        component: Createuserheader,
        layout: "/admin",
        isSuperAdmin: false,
        isAdmin: false,
        isVerifier: false,
        isUser: false,
        isECSAgent: false,
      },

      {
        path: "/audit-trail",
        name: "Audit Trail",
        component: AuditTrail,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
      {
        path: "/Blacklist",
        name: "Blacklist",
        component: BlockList,
        layout: "/admin",
        isSuperAdmin: true,
        isAdmin: true,
        isVerifier: true,
        isUser: true,
        isECSAgent: false,
      },
    ],
  },
];

export default routes;
